module.exports = __webpack_public_path__ + "static/media/02290035-LDU0wSgs.f5d95c2a.JPG";